// !!! IMPORTANT only to add a new items to the end of this string and only in format 'color name--xxxxxx' where xxxxxx is the hex number without the # symbol
export default '' +
'Dakota Gray--4c4e50, ' +
'Light Brown--6e6052, ' +
'Cocoa Brown--624a42, ' +
'Dark Brown--463838, ' +
'Burnished Slate--595049, ' +
'Black--222020, ' +
'Roman Blue--547587, ' +
'Gallery Blue--205266, ' +
'Dark Blue--343a44, ' +
'Barn Red--873c30, ' +
'Crimson Red--9f3c38, ' +
'Classic Burgundy--543e40, ' +
'Forest Green--445648, ' +
'Fern Green--34403a, ' +
'Copper Metallic--996e48, ' +
'Kestral White--d8dcd9, ' +
'Bone White--d1cac3, ' +
'Cobblestone Ivory--e3cfb5, ' +
'Dakota Sand--a5917a, ' +
'Light Stone--c7bba3, ' +
'Rawhide--b5977a, ' +
'Clay Mist--9f9181, ' +
'Ash Gray--ada39c, ' +
'Smoke Gray--8d8985, ' +
'Charcoal Gray--625c62';